import { w } from 'windstitch';

export const Wrapper = w.footer(
  'w-full p-4 xl:p-0 xl:w-[1200px] my-[32px] lg:my-[64px] ',
);

export const LogoBox = w.div(
  'flex flex-col items-center gap-[16px] md:gap-[32px] mb-[32px]',
);

export const PLogo = w.p(
  'font-roboto font-semibold text-base leading-6 tracking-[1px] text-center',
);

export const ContactBox = w.div(
  'flex flex-col md:flex-row items-center justify-center md:gap-[256px] gap-y-[16px] md:gap-y-0',
);


export const Paragraph = w.p(
  'font-roboto font-semibold text-[16px] leading-[24px] tracking-[1px] text-center',
);

export const ParagraphSpan = w.span(
  'text-[var(--lime-500)]',
);